(function () {
  'use strict';

  // Helper: root path an toàn (locale-aware), fallback '/' nếu Shopify chưa init
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Helper: nút .otsb-upsell-atc có phải nút "Choose" (sản phẩm nhiều biến thể)?
  // Nhiều biến thể → cần chọn → mở quick view. Single variant → add trực tiếp.
  function isChooseButton(btn) {
    return parseInt(btn.getAttribute('data-variants-length') || '1', 10) > 1;
  }

  // =========================================================================
  // 1) CỜ fromUpsell — đánh dấu khi click đúng nút Add của block upsell.
  //    Dùng để lọc: chỉ /cart/add.js phát sinh từ nút này mới xử lý (mục 3).
  // =========================================================================
  let fromUpsell = false;

  document.addEventListener(
    'click',
    function (e) {
      const atc = e.target.closest('.otsb-upsell-atc');
      // chỉ đánh dấu nút Add thật (single variant); nút Choose mở modal, không add
      if (atc && !isChooseButton(atc)) fromUpsell = true;
    },
    true
  );

  // =========================================================================
  // 2) INTERCEPT click <product-card> — chặn redirect của link overlay,
  //    mở quick view thay vì điều hướng về trang sản phẩm.
  //    ĐÂY là nơi `href` được lấy ra và openQuickView được gọi.
  // =========================================================================
  document.addEventListener(
    'click',
    function (e) {
      // chỉ áp cho product-card nằm trong block upsell (class chứa chuỗi này)
      const card = e.target.closest('product-card[class*="otsb_upsell_products"]');
      if (!card) return;

      // Nếu bấm vào nút .otsb-upsell-atc:
      const atc = e.target.closest('.otsb-upsell-atc');
      if (atc) {
        if (isChooseButton(atc)) {
          // nút "Choose" (nhiều biến thể) → mở quick view thay vì hành vi app
          e.preventDefault();
          e.stopPropagation();
          const link = card.querySelector('.product-card__link');
          const url =
            atc.getAttribute('data-product-url') || (link && link.getAttribute('href'));
          if (url) openQuickView({ url });
        }
        // nút "Add to cart" thật → không chặn, để app add (mục 3 lo hiện cart)
        return;
      }

      // để yên các control tương tác khác (không mở quick view khi bấm)
      if (e.target.closest('button, input, select, label, [role="button"]')) return;

      // còn lại (gồm click trúng link overlay / thân card) → chặn điều hướng
      e.preventDefault();
      e.stopPropagation();

      // data-* của card không có handle → lấy URL từ chính link overlay
      const link = card.querySelector('.product-card__link');
      const href = link ? link.getAttribute('href') : null;
      if (href) openQuickView({ url: href });
    },
    true // capture: bắt trước, chặn kịp navigation của thẻ <a>
  );

  // =========================================================================
  // 3) WRAP window.fetch — bắt thời điểm /cart/add.js từ block upsell add xong,
  //    rồi refresh + mở cart (drawer / notification) hoặc chuyển hướng.
  // =========================================================================
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add.js') !== -1;
    var wasUpsell = fromUpsell;
    if (isAdd) fromUpsell = false;

    var payload = null;
    if (isAdd && init && init.body) {
      try {
        payload = JSON.parse(init.body);
      } catch (err) {
        payload = init.body;
      }
    }

    var p = origFetch.apply(this, arguments);

    if (isAdd && wasUpsell) {
      p.then(function (res) {
        if (!res.ok) {
          console.warn('Add to cart FAILED', res.status);
          return;
        }
        // BẮT BUỘC clone: component của app cũng đọc res.json(), đọc 2 lần sẽ lỗi
        res.clone().json().then(function (data) {
          afterUpsellAdd(data);
        });
      }).catch(function () {});
    }
    return p;
  };

  // =========================================================================
  // 4) Sau khi add xong: refresh nội dung cart của theme rồi mở.
  //    - cart_type = drawer      → <cart-drawer>
  //    - cart_type = notification→ <cart-notification>  (cần .key)
  //    - cart_type = page        → không có element → chuyển hướng /cart
  // =========================================================================
  async function afterUpsellAdd(added) {
    const cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!cart) {
      window.location.href = root() + 'cart';
      return;
    }

    // lấy đúng tập section mà CHÍNH element đó cần (notification khác drawer)
    const ids = cart.getSectionsToRender().map((s) => s.id).join(',');
    const res = await fetch(root() + '?sections=' + ids);
    const sections = await res.json();

    // key BẮT BUỘC cho CartNotification: selector [id="cart-notification-product-<key>"]
    cart.renderContents({ sections, key: added.key });
  }

  // =========================================================================
  // 5) QUICK VIEW — tái dùng <quick-add-modal> của Dawn.
  //    Tạo scaffold đúng markup (né constructor/connectedCallback), rồi show().
  // =========================================================================
  function ensureQuickViewModal() {
    const existing = document.getElementById('QuickAdd-otupsell');
    if (existing) return existing;

    // quick-add.js phải đã nạp trên trang (Dawn định nghĩa custom element này)
    if (!customElements.get('quick-add-modal')) return null;

    // Bọc trong .shopify-section (né connectedCallback đọc closest('.shopify-section'))
    // + build đủ con trong 1 string (né constructor query ModalClose / QuickAddInfo)
    const wrapper = document.createElement('div');
    wrapper.className = 'shopify-section';
    wrapper.id = 'shopify-section-otupsell-quickview';
    wrapper.innerHTML =
      '<quick-add-modal id="QuickAdd-otupsell" class="quick-add-modal">' +
      '  <div role="dialog" aria-modal="true" tabindex="-1"' +
      '       class="quick-add-modal__content global-settings-popup">' +
      '    <button id="ModalClose-otupsell" type="button"' +
      '            class="quick-add-modal__toggle" aria-label="Close">✕</button>' +
      '    <div id="QuickAddInfo-otupsell" class="quick-add-modal__content-info"></div>' +
      '  </div>' +
      '</quick-add-modal>';
    document.body.appendChild(wrapper); // connectedCallback tự dời modal ra body
    return document.getElementById('QuickAdd-otupsell');
  }

  async function openQuickView(opts) {
    const raw = opts && opts.url;
    if (!raw) return;
    const base = raw.split('?')[0].split('#')[0];

    const modal = ensureQuickViewModal();
    // không dựng được modal (quick-add.js chưa nạp) → fallback về product page
    if (!modal) {
      window.location.href = raw;
      return;
    }

    // Tạm bỏ check template gốc → luôn ép ?view=quickview để mở quick view (không cần template gốc có product-info).
    let url = base + '?view=quickview';

    // opener giả: show() cần data-product-url + con .loading__spinner
    const opener = document.createElement('button');
    opener.type = 'button';
    opener.setAttribute('data-product-url', url);
    opener.innerHTML = '<span class="loading__spinner hidden"></span>';

    modal.show(opener); // Dawn tự fetch url → lấy <product-info> → nhét vào #QuickAddInfo → mở
  }
})();